import { Link } from "react-router-dom";
import { Logo } from "@/components/Brand";

export default function Footer() {
  return (
    <footer className="bg-[#1C1917] text-stone-300 mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2 space-y-4">
          <Logo dark testId="footer-tenet-logo" />
          <p className="text-sm text-stone-400 max-w-sm leading-relaxed">
            A warm, faith-informed and science-informed approach to change. Hypnotherapy is offered
            as a supportive tool that may help and is meant to complement appropriate care.
          </p>
          <Link
            to="/consultation"
            data-testid="footer-consultation-cta"
            className="inline-flex btn-terracotta rounded-full px-5 py-2.5 text-sm font-semibold"
          >
            Request a free 30-minute consultation
          </Link>
        </div>

        <div>
          <h4 className="text-stone-100 font-playfair text-lg mb-4">Explore</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link className="hover:text-amber-400" to="/about" data-testid="footer-link-about">About Jonathan</Link></li>
            <li><Link className="hover:text-amber-400" to="/sacred-flame" data-testid="footer-link-sacred">Sacred Flame</Link></li>
            <li><Link className="hover:text-amber-400" to="/assessments" data-testid="footer-link-assessments">Assessments</Link></li>
            <li><Link className="hover:text-amber-400" to="/experiences" data-testid="footer-link-experiences">Client Experiences</Link></li>
            <li><Link className="hover:text-amber-400" to="/faq" data-testid="footer-link-faq">FAQ</Link></li>
            <li><Link className="hover:text-amber-400" to="/video-series" data-testid="footer-link-videos">Chapter Videos</Link></li>
            <li><Link className="hover:text-amber-400" to="/zoom" data-testid="footer-link-zoom">Weekly Session</Link></li>
            <li><Link className="hover:text-amber-400" to="/book" data-testid="footer-link-book">Free Book</Link></li>
            <li><Link className="hover:text-amber-400" to="/members" data-testid="footer-link-members">Member Area</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-stone-100 font-playfair text-lg mb-4">Care & Privacy</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link className="hover:text-amber-400" to="/disclaimer" data-testid="footer-link-disclaimer">Care Disclaimer</Link></li>
            <li><Link className="hover:text-amber-400" to="/privacy" data-testid="footer-link-privacy">Privacy Policy</Link></li>
          </ul>
          <p className="text-xs text-stone-300 mt-5 leading-relaxed">
            If you are in crisis or danger, please contact your local emergency number or a crisis line
            immediately. This site does not provide emergency services.
          </p>
        </div>
      </div>
      <div className="border-t border-stone-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-6 flex flex-col sm:flex-row justify-between gap-3 text-xs text-stone-500">
          <p>© {new Date().getFullYear()} TENET Transformation. All rights reserved.</p>
          <p>Hypnotherapy is a supportive tool and does not replace medical or clinical treatment.</p>
        </div>
      </div>
    </footer>
  );
}
